export default "__VITE_ASSET__CKonhJQe__"